import React, { useEffect, useState } from "react";
import ViewPreDefinedIndex from "../../../../components/View/ViewPreDefinedIndex";
import { useStandard } from "../../../../context/StandardContext";
import useGetStandardDetail from "../../../../hooks/useGetStandardDetail";
import { useLocation, useParams } from "react-router-dom";
import useFetchPreReport from "../../../../hooks/useFetchPreReport";
import NuDateFormat from "../../../../utils/NuDate";
import { CloseIcon, PaperClip } from "../../../../assets/icons";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../../utils/OtherFunctions";
import { NuDate } from "../../../../utils/Inputs";
import FormikSelectTwo from "../../../../utils/Select";
import { CancelButton, SubmitButton } from "../../../../utils/Button";
import useGetStatusData from "../../../../hooks/useGetStatusData";
import DecryptData from "../../../../utils/Decrypt";
import useGetCompanyInfo from "../../../../hooks/useGetCompanyInfo";
import PDFGenerationScreen from "../../PDFGenerationScreen";

function TrainingCalendarReport() {
  const { standardName } = useStandard();
  const { stdId } = useParams();
  let location = useLocation();

  console.log("ssslocation",location.state);
  
  const [value, setValue] = useState({
    standard_id: stdId,
    module_id: 16,
    type: location.state?.reportValue?.reset_count || 0,
    status_name: "",
    from_date:"",
    to_date:"",
  });

  const [params, setParams] = useState({
    standard_id: stdId,
    module_id: 16,
    type: location.state?.reportValue?.reset_count || 0,
    status_name: "",
    from_date: "",
    to_date:"",
    completion_start_date: "",
    completion_end_date: "",
    reminder_start_date: "",
    reminder_end_date: "",
  });

  const { statusValue } = useGetStatusData({ value: 12 });
  const [filter, setFilter] = useState(false);
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const { data, isLoading, review, getAllData,status } = useFetchPreReport({
    url: `/report/`,
    value: filter==true?params:value,
    hasFilter: filter,
  });
  const [showFiter, setShowFilter] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: params,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      console.log();
      setParams(value);
      setFilter(true)
      setTimeout(() => {
        setShowFilter(false);
      }, 600);
    },
  });

  function handleOnClose() {
    setShowFilter(false);
    formik.resetForm();
    setParams(value)
    setFilter(false)
  }

  const [pdfUrl, setPdfUrl] = useState(null);
  const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];
  const {company}=useGetCompanyInfo()
  const [isDataLoading,setIsDataLoading]=useState(true)
  useEffect(() => {
    const worker = new Worker(new URL('./tcPDFWorker.jsx', import.meta.url));
    
    if(data.length>0){
      worker.onmessage = (e) => {
        setPdfUrl(e.data);
        setIsDataLoading(false);
      };
    }

    if (data.length > 0) {
      worker.postMessage({
        data,
        company:company,
        standardDetailName,
        review,
        standardStartDate,
        standardEndDate,
        Name: `Training Calendar Report`,
        UserName: userData?.user_name,
        Location: userData?.location || "-",
        Country: userData?.country || "-",
        department: userData?.department || "-",
        header,
        status,
      });
    }else{
      setIsDataLoading(false);
    }

   return () => {
      setIsDataLoading(false);
      worker.terminate();
    }
  }, [data,company,standardDetailName]);

  return (
    <>
      <ViewPreDefinedIndex
        label="Training Calendar"
        standardName={standardName}
        menu="Report"
        header={header}
        isLoading={isLoading}
        review={review}
        hasFilter={filter}
        removeFilter={handleOnClose}
        dataView={data}
        startDate={standardStartDate}
        endDate={standardEndDate}
        setShowFilter={() => setShowFilter(true)}
        pdfUrl={pdfUrl}
        downloadFileName={`${standardName}-Training Calendar Report ${
          standardStartDate &&
          NuDateFormat({
            value: standardStartDate,
            format: "MMM-YYYY",
          })
        } ${
          (standardEndDate ||
            standardEndDate) &&
          "to"
        } ${
          (standardEndDate ||
            standardEndDate) &&
          NuDateFormat({
            value:
            standardEndDate ||
            standardEndDate,
            format: "MMM-YYYY",
          })
        }.pdf`}

      />
      {showFiter && (
        <>
          <div
            id="modal"
            className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
    flex justify-center items-center "
          >
            <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
              <div className="flex items-start justify-between px-5 py-2  rounded-t">
                <h3 className="text-base 2xl:text-lg font-semibold">Filter</h3>
                <span
                  className="h-6 w-6 text-2xl block cursor-pointer"
                  onClick={handleOnClose}
                >
                  <CloseIcon />
                </span>
              </div>
              <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                <div className=" w-full max-h-[70vh] overflow-y-auto relative px-6 flex flex-wrap justify-between">
                  <FormikSelectTwo
                    formik={formik}
                    name="status_name"
                    label="Status"
                    width="w-full"
                    placeholder="Select Status"
                    Options={statusValue}
                    zindex={12}
                  />
                </div>
                <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                  <CancelButton onClose={handleOnClose} />
                  <SubmitButton />
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    <PDFGenerationScreen visible={isDataLoading} activity={"Training Calendar Report"} format={"pdf"} name={standardName}/>
    </>
  );
}

export default TrainingCalendarReport;

const header = [
  {
    headone: "Sl No.",
    width: "w-[5%]",
    fieldname: "serial_number",
    type: "text",
    pdfWidth:"5%",
    textAlign:"center"
  },
  {
    headone: "Training Program",
    width: "w-[14%]",
    fieldname: "training_program",
    type: "text",
    pdfWidth:"14%",
    textAlign:"center"
  },
  {
    headone: "Function Responsibility",
    width: "w-[14%]",
    fieldname: "function_responsibility",
    type: "text",
    pdfWidth:"14%",
    textAlign:"center"
  },
  {
    headone: "Frequency",
    width: "w-[10%]",
    fieldname: "frequency",
    type: "text",
    pdfWidth:"10%",
    textAlign:"center"
  },
  {
    headone: "Participants",
    width: "w-[10%]",
    fieldname: "participants",
    type: "text",
    pdfWidth:"10%",
    textAlign:"center"
  },
  {
    headone: "Mandatory for \n the organization",
    width: "w-[14%]",
    fieldname: "mandatory",
    type: "text",
    pdfWidth:"14%",
    textAlign:"center",
    feildnametwo:"created_name",

  },
  {
    headone: "Detail Plan",
    width: "w-[10%]",
    fieldname: "detail_plan",
    type: "text",
    pdfWidth:"10%",
    textAlign:"center",
  },
  {
    headone: "Planned Date",
    width: "w-[10%]",
    fieldname: "planned_date",
    type: "date",
    pdfWidth:"10%",
    textAlign:"center",
  },
  {
    headone: "Status",
    width: "w-[8%]",
    fieldname: "status",
    type: "text",
    pdfWidth:"8%",
    textAlign:"center",
  },
  {
    headone: "Artefact",
    width: "w-[5%]",
    fieldname: "attachment",
    type: "file",
    pdfWidth:"5%",
    textAlign:"center",
  },
];